import JsonFormsWrapper from '@/components/common/jsonForms/jsonFormsWrapper/JsonFormsWrapper'
import {
  OrderIdentifiersJSONSchema,
  OrderIdentifiersJSONUiSchema,
} from '@/services/MockData/Order/OrderDigitalPayment/OrderIdentifiersJSON'
import {
  PaymentTranStsJSONSchema,
  PaymentTranStsJSONUiSchema,
} from '@/services/MockData/Order/OrderDigitalPayment/PaymentTranStsJSON'
import {PayScheJSONSchema, PayScheJSONUiSchema} from '@/services/MockData/Order/OrderDigitalPayment/PayScheJSON'

import {PageContainer} from '@/components/organisms'
import {SectionTitle} from '@/components/molecules'

const OrderDigitalPaymentPage = ({OrderDetails}) => {
  // Destructure OrderDetails for easy access
  const {
    createdDateTime,
    subTotal,
    invoiceDateTime,
    orderType,
    orderLocationId,
    sourceOrderId,
    routeId,
    routeTypeId,
    routeSalesRepWorkForceId,
  } = OrderDetails

  // Helper component to render each section with JsonFormsWrapper
  const RenderSection = ({id, title, jsonSchema, uiSchema, data}) => (
    <div>
      <SectionTitle id={id} title={title} />
      <div className="pt-5">
        <JsonFormsWrapper jsonschema={jsonSchema} uischema={uiSchema} data={data} />
      </div>
    </div>
  )

  return (
    <PageContainer>
      {/* Order Identifiers Section */}
      <RenderSection
        id="order_identifiers"
        title="Order Identifiers"
        jsonSchema={OrderIdentifiersJSONSchema}
        uiSchema={OrderIdentifiersJSONUiSchema}
        data={{
          paymentTransactionId: createdDateTime,
          sfOrderId: subTotal,
          paymentTransactionSystem: invoiceDateTime,
        }}
      />

      {/* Payment Information Section */}
      <RenderSection
        id="payment_information"
        title="Payment Information"
        jsonSchema={PaymentTranStsJSONSchema}
        uiSchema={PaymentTranStsJSONUiSchema}
        data={{
          paymentTransactionStatus: orderType,
          paymentTransactionAmount: orderLocationId,
          transactionDate: sourceOrderId,
          paymentMethodCode: sourceOrderId,
          cardType: sourceOrderId,
          lastFourDigitCard: sourceOrderId,
        }}
      />

      {/* Schedule & Payment Details Section */}
      <RenderSection
        id="schedule_payment_details"
        title="Schedule & Payment Details"
        jsonSchema={PayScheJSONSchema}
        uiSchema={PayScheJSONUiSchema}
        data={{
          visitScheduleId: routeId,
          custPoId: routeTypeId,
          payTermsCode: routeSalesRepWorkForceId,
          orPayStat: routeSalesRepWorkForceId,
        }}
      />
    </PageContainer>
  )
}

export default OrderDigitalPaymentPage
